<template>
  <label v-if="label" :for="id">{{ label }}</label>
  <input
    v-bind="{
      ...$attrs,
      onInput: updateValue,
    }"
    :id="id"
    :type="type"
    :placeholder="finalPlaceholder()"
    :value="modelValue"
  />
</template>
<script setup>
const props = defineProps({
  id: {
    type: String,
  },
  label: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "text",
  },
  modelValue: {
    type: String,
  },
  placeholder: {
    type: String,
    default: "",
  },
})
const emit = defineEmits(["update:modelValue"])
const updateValue = (event) => {
  emit("update:modelValue", event.target.value)
}

const finalPlaceholder = () => {
  return props.placeholder != "" ? props.placeholder : props.label
}
</script>
<style>
input {
  font-size: 1.1rem;
  padding: 14px;
}
</style>
